"use client";

import { Suspense } from "react";
import { useMarketingAttributionCapture } from "~/hooks/use-marketing-attribution";

function MarketingAttributionCaptureInner() {
  useMarketingAttributionCapture();
  return null;
}

/** Captures UTMs / click IDs on marketing pages (wrap in Suspense for useSearchParams). */
export function MarketingAttributionCapture() {
  return (
    <Suspense fallback={null}>
      <MarketingAttributionCaptureInner />
    </Suspense>
  );
}
